import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import MonthPicker from 'components/molecules/datepicker/monthPicker';

import s from './styles.module.scss';

import type { Filters } from 'infrastructure/hooks/interactiveTimeDashboard/types';

interface IProps {
  filters: Filters;
  appendFilters: (filter: Partial<Filters>) => void;
}

const TimeRangeFilter: FC<IProps> = ({ appendFilters, filters }) => {
  const { t } = useTranslation();

  const handleChange = (year: number, month: number) => {
    appendFilters({
      year,
      month,
    });
  };

  return (
    <div className={s['available-billable-minutes-wrapper']}>
      <label data-cy="interactiveTimeDashboard-filter-timeRange">
        {t('labels.timeRange')}
      </label>
      <MonthPicker
        allowClear={false}
        value={{ year: filters.year, month: filters.month }}
        onChange={(value) => {
          if (!value) {
            handleChange(new Date().getFullYear(), new Date().getMonth());
          } else {
            handleChange(value.year, value.month);
          }
        }}
      />
    </div>
  );
};

export default TimeRangeFilter;
